import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CartItem } from '../entities/cart-item';
import { B2bCartNotification, CartNotificationType } from '../entities/b2b-cart-notification';
import { B2bCartNotificationService } from '../services/b2b-cart-notification.service';

@Component({
  selector: 'app-b2b-cart-summary-notifications',
  templateUrl: './b2b-cart-summary-notifications.component.html',
  styleUrls: ['./b2b-cart-summary-notifications.component.scss'],
  standalone: false
})
export class B2bCartSummaryNotificationsComponent implements OnChanges {
  @Input() cartItems: CartItem[] = [];
  @Input() messagePrefix = 'One or more items in your cart have';

  errorCount = 0;
  warningCount = 0;

  constructor(private cartNotificationService: B2bCartNotificationService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cartItems']) {
      this.updateNotificationCounts();
    }
  }

  private updateNotificationCounts(): void {
    if (!this.cartItems?.length) {
      this.errorCount = 0;
      this.warningCount = 0;
      return;
    }

    const notifications = this.cartNotificationService.buildNotifications(this.cartItems);

    this.errorCount = notifications.filter(
      (notification: B2bCartNotification) => notification.type === CartNotificationType.Error
    ).length;

    this.warningCount = notifications.filter(
      (notification: B2bCartNotification) => notification.type === CartNotificationType.Warning
    ).length;
  }

  get hasErrors(): boolean {
    return this.errorCount > 0;
  }

  get hasWarnings(): boolean {
    return this.warningCount > 0;
  }

  get errorMessage(): string {
    return `${this.messagePrefix} ${this.errorCount} ${this.errorCount === 1 ? 'error' : 'errors'}`;
  }

  get warningMessage(): string {
    return `${this.messagePrefix} ${this.warningCount} ${this.warningCount === 1 ? 'warning' : 'warnings'}`;
  }
}
